import { createRoot, lazy, createElement } from 'react'

const OrgsShopPage = lazy( () => import('./Shop'))

if ( document.getElementById('membersync-organizations-shop-page-content') ) {
    const rootElement = document.getElementById('membersync-organizations-shop-page-content')

    const dataProps = {}
    const component = createElement(OrgsShopPage, dataProps)

    createRoot ? createRoot(rootElement).render(component) : render(component, rootElement);
}

